import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

fetch('assets/config/environment_config.json')
  .then((response) => (response.ok ? response.json() : null))
  .then((config) => {
    if (config && typeof config === 'object') {
      Object.assign(environment, config);
      console.info(
        'Environment-Konfiguration erfolgreich aus assets/config/environment_config.json geladen.',
      );
    }
  })
  .catch((error) => {
    console.warn(
      'Keine externe assets/config/environment_config.json gefunden oder Fehler beim Laden, Standard-Environment wird genutzt:',
      error,
    );
  })
  .finally(() => {
    if (environment.production) {
      enableProdMode();
    }

    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  });
